import { render, staticRenderFns } from "./setup.html?vue&type=template&id=1f0f05c5&scoped=true&"
import script from "./setup.js?vue&type=script&lang=js&"
export * from "./setup.js?vue&type=script&lang=js&"
import style0 from "./setup.sass?vue&type=style&index=0&id=1f0f05c5&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0f05c5",
  null
  
)

component.options.__file = "setup.vue"
export default component.exports